import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { PropTypes } from '@material-ui/core/index'
import { Variant } from '@material-ui/core/styles/createTypography'
import cls from 'classnames'

import { useStyles } from './styles'

type CommonTableProps = {
  headers: string[]
  rows: string[][]
  contentVariants?: string[]
  alignVariants?: string[]
  proportions?: string
  cellBorders?: string
  cellBorderColor?: string
  cellBorderStyle?: string
  className?: string
}
export default function CommonTable({
  headers,
  rows,
  proportions = 'none',
  cellBorders = 'unset',
  cellBorderColor = 'none',
  cellBorderStyle = 'unset',
  contentVariants = [],
  alignVariants = [],
  className,
}: CommonTableProps) {
  const classes = useStyles()

  return (
    <Table className={cls(classes.main, className)}>
      <TableHead>
        <TableRow
          className={classes.row}
          style={{
            gridTemplateColumns: proportions,
          }}
        >
          {headers.map((column, idx) => (
            <TableCell key={column} className={classes.cell}>
              <Typography
                variant={'subtitle1'}
                align={(alignVariants[idx] as PropTypes.Alignment) ?? 'left'}
              >
                {column}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((tableRow: string[], idx: number) => (
          <TableRow
            key={'table-row-' + idx}
            className={classes.row}
            style={{
              gridTemplateColumns: proportions,
              borderWidth: cellBorders,
              borderColor: cellBorderColor,
              borderStyle: cellBorderStyle,
            }}
          >
            {tableRow.map((cell, idx) => (
              <TableCell key={cell + idx} className={classes.cell}>
                <Typography
                  variant={(contentVariants[idx] as Variant) ?? 'body1'}
                  align={(alignVariants[idx] as PropTypes.Alignment) ?? 'left'}
                >
                  {cell}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
